import React, { useState } from "react";
import Visualization from "./Visualization";
import { AudioProfileProvider } from "../contexts/AudioProfileContext";

const GENES = [
  "ACTG1",
  "CCDC50",
  "CEACAM16",
  "COCH",
  "COL11A2",
  "EYA4",
  "DIAPH1",
  "GJB2",
  "GRHL2",
  "GSDME",
  "KCNQ4",
  "MIRN96",
  "MYH14",
  "MYH9",
  "MYO6",
  "MYO7A",
  "P2RX2",
  "POU4F3",
  "REST",
  "SLC17A8",
  "TECTA",
  "TMC1",
  "WFS1",
];

const AudioGeneWalkthrough = () => {
  const [hypothesis, setHypothesis] = useState({
    selectedGenes: GENES,
    resampling: {},
    selectedParameters: {
      multiInstance: false,
      singleInstance: false,
    },
    customModel: false,
    allGeneData: [],
    audiogramPredicted: false,
    predictAudioProfiles: false,
    predictedData: [],
  });

  return (
    <div>
      <Visualization
        hypothesis={hypothesis}
        setHypothesis={setHypothesis}
        allGenes={GENES}
      />
    </div>
  );
};

export default AudioGeneWalkthrough;
